var map = {
	"./img-char-Amelia-middle@2x.png": 475,
	"./img-char-Amelia@2x.png": 476,
	"./img-char-Harper-middle@2x.png": 477,
	"./img-char-Harper@2x.png": 478,
	"./img-char-Lamar-middle@2x.png": 479,
	"./img-char-Lamar@2x.png": 480,
	"./img-char-Paco-middle@2x.png": 481,
	"./img-char-Paco@2x.png": 482,
	"./img-char-Philo-middle@2x.png": 483,
	"./img-char-Philo@2x.png": 484,
	"./img-char-Ruby-middle@2x.png": 485,
	"./img-char-Ruby@2x.png": 486,
	"./img-haus-Amelia@2x.png": 487,
	"./img-haus-Foundation@2x.png": 488,
	"./img-haus-Harper@2x.png": 489,
	"./img-haus-Lamar@2x.png": 490,
	"./img-haus-Paco@2x.png": 491,
	"./img-haus-Philo@2x.png": 492,
	"./img-haus-Ruby@2x.png": 493,
	"./img-nopic@2x.png": 494
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332;



//////////////////
// WEBPACK FOOTER
// ./app/features/dashboard/images ^\.\/.*@2x\.png$
// module id = 332
// module chunks = 0